import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=e5ff01ce"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=e5ff01ce&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5ff01ce')) {
      api.createRecord('e5ff01ce', component.options)
    } else {
      api.reload('e5ff01ce', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=e5ff01ce", function () {
      api.rerender('e5ff01ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Campaigns.vue"
export default component.exports